import { render, staticRenderFns } from "./mind-map-test-form.vue?vue&type=template&id=786103a4&scoped=true&"
import script from "./mind-map-test-form.vue?vue&type=script&lang=js&"
export * from "./mind-map-test-form.vue?vue&type=script&lang=js&"
import style0 from "./mind-map-test-form.vue?vue&type=style&index=0&id=786103a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786103a4",
  null
  
)

export default component.exports